var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-attribute-panel',{ref:"editor",attrs:{"attribute":_vm.editor.options,"value":_vm.getValue,"displayLabel":false,"activateSearch":false,"activateValidationMessages":false},on:{"valueChanged":_vm.onValueChanged,"searchRequested":_vm.onSearchRequested,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }